import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Poupe {{percentageAmount}}% em artigos selecionados',
    description:
      'Poupe {{percentageAmount}}% na sua encomenda ao pedir artigos selecionados. A oferta é válida{{fromTo}} até ser atingido o limite máximo de promoções, o que ocorrer primeiro. Não é combinável com outras promoções.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% de desconto a partir de {{minSpendValue}}',
    description:
      'Poupe {{percentageAmount}}% na sua encomenda. A oferta é válida{{fromTo}} até ser atingido o limite máximo de promoções, o que ocorrer primeiro. Não é combinável com outras promoções.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Poupe {{amount}} em artigos selecionados',
    description:
      'Poupe {{amount}} ao pedir artigos selecionados. A oferta é válida{{fromTo}} até ser atingido o limite máximo de promoções, o que ocorrer primeiro. Não é combinável com outras promoções.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Poupe {{amount}} a partir de {{minSpendValue}}',
    description:
      'Poupe {{amount}} com o valor da encomenda. A oferta é válida{{fromTo}} até ser atingido o limite máximo de promoções, o que ocorrer primeiro. Não é combinável com outras promoções.',
  },
  [OfferKindEnum.Bogo]: {
    title: 'Leve 2 pelo preço de 1!',
    description:
      'Compre um artigo e leve o segundo gratuitamente. A oferta é válida{{fromTo}} até ser atingido o limite promocional, o que ocorrer primeiro. Não é combinável com outras promoções.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Compre um e leve o segundo a metade do preço!',
    description:
      'Compre um artigo e leve o segundo a metade do preço. A oferta é válida{{fromTo}} até ser atingido o limite promocional, o que ocorrer primeiro. Não é combinável com outras promoções.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Artigo gratuito com valor de encomenda',
    description:
      'Receba um artigo gratuito ao cumprir as condições da oferta. A oferta é válida{{fromTo}} até ser atingido o limite promocional, o que ocorrer primeiro. Não é combinável com outras promoções.',
    reward_items_description: 'Escolha o seu artigo gratuito.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Artigo gratuito com a sua encomenda',
    description:
      'Receba um artigo gratuito ao cumprir as condições da oferta. A oferta é válida{{fromTo}} até ser atingido o limite promocional, o que ocorrer primeiro. Não é combinável com outras promoções.',
    qualifying_items_description: 'Selecione os artigos que o cliente deve pedir para obter o artigo gratuito.',
    reward_items_description: 'Escolha o seu artigo gratuito.',
  },
};

export default {
  offers,
  from_to: ' de {{startsAt}} a {{endsAt}} ou',
  qualifying_items_title: 'Artigos qualificados',
  reward_items_title: 'Artigos gratuitos',
  buttons: {
    add: 'Adicionar ao carrinho',
  },
};
